import { Form, Input, Select } from 'antd';
import { map } from 'lodash';
import React from 'react';
import countryCode from '../assets/countryCode.json';

const PhoneNumberInputWithCountyCode = ({
  formItemName = 'countryCode',
  disabled = false,
  ...rest
}) => {
  return (
    <Input
      className="country-code-phone-input"
      allowClear
      disabled={disabled}
      addonBefore={
        <Form.Item name={formItemName} className="country-code-input">
          <Select
            showSearch
            disabled={disabled}
            placeholder="Code"
            options={[
              ...map(countryCode, (record) => {
                return {
                  key: record?.id,
                  value: record?.dialCode,
                  label: record?.dialCode,
                };
              }),
            ]}
          />
        </Form.Item>
      }
      placeholder="Enter Mobile Number"
      {...rest}
    />
  );
};

export default PhoneNumberInputWithCountyCode;
